import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

import { ConfirmModalProps } from "../../types";
import { COMMON_STRINGS } from "../../constants/strings";

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  title,
  description,
  onClose,
  onConfirm,
  confirmText,
  cancelText,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <Typography>{description}</Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>
          {cancelText || COMMON_STRINGS.BTN_CANCEL}
        </Button>

        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            backgroundColor: "var(--danger)",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "var(--danger)",
            },
          }}
        >
          {confirmText || COMMON_STRINGS.BTN_CONFIRM}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;